import React, { useContext } from 'react'
import { Translation } from 'react-i18next'
import CIcon from '@coreui/icons-react'
import { cilSettings } from '@coreui/icons'
import { CNavItem, CNavTitle } from '@coreui/react-pro'
import { GlobalVariablesContext } from './contexts/globalVariableContext'

export const TenderNavigation = () => {
  const { tenderChapters } = useContext(GlobalVariablesContext)

  let _tenderNavigation = [
    {
      component: CNavTitle,
      name: <Translation>{(t) => t('TenderDetailView.pageTitle')}</Translation>,
    },
  ]
  tenderChapters &&
    tenderChapters
      .sort((a, b) => (a.npkNumber > b.npkNumber ? 1 : -1))
      .map((item) => {
        _tenderNavigation.push({
          component: CNavItem,
          name: `${item.content ? item.content : item.npkNumber}`,
          href: `#${item.name}`,
          icon: <CIcon icon={cilSettings} customClassName='nav-icon' />,
        })
      })
  return _tenderNavigation
}
